export default {"src":"/_next/static/media/linkedin.ddb84909.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};